import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=edcc86ba&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=edcc86ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edcc86ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edcc86ba')) {
      api.createRecord('edcc86ba', component.options)
    } else {
      api.reload('edcc86ba', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=edcc86ba&scoped=true&", function () {
      api.rerender('edcc86ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25fBCgDQAMkcP/JS/comp/SearchFilterTokens.vue"
export default component.exports